export const AVAILABILITIES_PATH = "/v1/workers/availability";

export const AVAILABILITY_DATE_FORMAT = "yyyy-MM-dd";

export const WORKER_DISTANCE_CRITERIA_MAX_VALUE = 150;

export const DEFAULT_WORKER_DISTANCE_CRITERIA = WORKER_DISTANCE_CRITERIA_MAX_VALUE;
export const DEFAULT_AUTO_BOOKING_IS_ENABLED = false;
